import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Icon
} from "@mui/material";
import { Add, DeleteForeverOutlined, EditOutlined } from "@mui/icons-material";
import { styled } from "@mui/system";
import React, { CSSProperties, Component } from "react";
import swal from "sweetalert";
import DeliveraActionCreators from "../../../controller/action/DeliveraActionCreators";
import DeliveraCategory, {
  DeliveraCategoryInterface,
} from "../../../controller/model/delivera/DeliveraCategorie";
import DeliveraItem, {
  DeliveraItemInterface,
} from "../../../controller/model/delivera/DeliveraItem";
import DeliveraMenu, {
  DeliveraMenuInterface,
} from "../../../controller/model/delivera/DeliveraMenu";
import { DeliveraStore } from "../../../controller/model/delivera/DeliveraStore";
import { DeliveraModifierGroupInterface } from "../../../controller/model/delivera/interface";
import PopinaRestaurant from "../../../controller/model/popina/PopinaRestaurant";
import Environment from "../../../utils/Environement";
import { ItemDetailModalComponet } from "../item/ItemDetailModalComponet";
import DeliveraMenuDetailModal from "../menu/DeliveraMenuDetailModal";
import GroupeOptionDetailModalComponent from "../options/GroupeOptionComponentModal";
import CategoryDetailModalComponent from "./CategoryDetailModalComponent";
import ItemCategoryComponent from "./ItemCategoryComponent";

interface PropsInterface {
  store: DeliveraStore;
  restaurant: PopinaRestaurant;
}

interface StateInterface { }

export default class CategoryComponent extends Component {
  public props: PropsInterface;
  public state: StateInterface;

  private groupeOptionModalRef: React.RefObject<
    GroupeOptionDetailModalComponent
  >;
  private itemDetailModalRef: React.RefObject<ItemDetailModalComponet>;
  private categoryDetailModalRef: React.RefObject<CategoryDetailModalComponent>;
  private menuDetailModalRef: React.RefObject<DeliveraMenuDetailModal>;

  constructor(props: any) {
    super(props);
    this.props = props;
    this.state = {};
    this.groupeOptionModalRef = React.createRef();
    this.itemDetailModalRef = React.createRef();
    this.categoryDetailModalRef = React.createRef();
    this.menuDetailModalRef = React.createRef();
    this.initBindings();
  }

  private initBindings() {
    this.updateItem = this.updateItem.bind(this);
    this.updateCategory = this.updateCategory.bind(this);
    this.handleSelectItem = this.handleSelectItem.bind(this);
    this.handleTapAddItem = this.handleTapAddItem.bind(this);
    this.createItemInCategory = this.createItemInCategory.bind(this);
    this.updateGroupeModifier = this.updateGroupeModifier.bind(this);
    this.removeItemFromCatgory = this.removeItemFromCatgory.bind(this);
    this.handleTapEditCategory = this.handleTapEditCategory.bind(this);
    this.handleSelectGroupeOption = this.handleSelectGroupeOption.bind(this);
    this.deleteGroupeModifierFromItem = this.deleteGroupeModifierFromItem.bind(
      this
    );
    this.handleSelectMenu = this.handleSelectMenu.bind(this);
    this.handlTapSaveMenu = this.handlTapSaveMenu.bind(this);
    this.handleTapAddCategory = this.handleTapAddCategory.bind(this);
    this.createCategorie = this.createCategorie.bind(this);
    this.handleTapAddGroupeOption = this.handleTapAddGroupeOption.bind(this);
    this.handleTapCreateGroupeOption = this.handleTapCreateGroupeOption.bind(
      this
    );
    this.handleTapDeleteMenu = this.handleTapDeleteMenu.bind(this);
  }

  componentDidMount() { }

  componentWillUnmount() { }

  render() {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          backgroundColor: "#f9fafa",
          position: "static",
        }}
      >
        <ItemDetailModalComponet
          onClickSave={this.updateItem}
          onClickGroupeOption={this.handleSelectGroupeOption}
          onClickRemove={this.removeItemFromCatgory}
          onClickCreate={this.createItemInCategory}
          restaurant={this.props.restaurant}
          store={this.props.store}
          ref={this.itemDetailModalRef}
        />
        <GroupeOptionDetailModalComponent
          store={this.props.store}
          restaurant={this.props.restaurant}
          onClickDelete={this.deleteGroupeModifierFromItem}
          onClickSave={this.updateGroupeModifier}
          onClickCreate={this.handleTapCreateGroupeOption}
          ref={this.groupeOptionModalRef}
        />
        <CategoryDetailModalComponent
          store={this.props.store}
          onClickSave={this.updateCategory}
          onClickCreate={this.createCategorie}
          ref={this.categoryDetailModalRef}
        />

        <DeliveraMenuDetailModal
          ref={this.menuDetailModalRef}
          handleTapSave={this.handlTapSaveMenu}
          store={this.props.store}
        />

        <AddCategoButton
          onClick={(_e: any) => {
            this.handleTapAddCategory();
          }}
        >
          Ajouter une catégorie
        </AddCategoButton>

        <div
          style={{ backgroundColor: "#f9fafa", marginTop: "2em" }}
          key={"menu_"}
        >
          <Card
            style={{
              margin: "20px 3em",
            }}
          >
            <CardHeader
              title="Mes Menus"
              subheaderTypographyProps={{
                style: {
                  color: "white",
                },
              }}
              titleTypographyProps={{
                style: {
                  fontWeight: "bold",
                  fontSize: "20px",
                },
              }}
              style={{
                backgroundColor: "#474F5E",
                color: "white",
              }}
            />

            <CardContent
              style={{
                display: "flex",
                flexWrap: "nowrap",
                backgroundColor: "#F1F1F5",
              }}
            >
              {this.props.store.menus?.map((aMenu) => {
                return (
                  <MenuStyledButton key={aMenu.id}>
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "250px",
                        height: "150px",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "19px",
                          color: (Environment.isPopina) ? "#42b983" : "#ffd400",
                          margin: "auto",
                          textAlign: "center",
                        }}
                      >
                        {`${DeliveraStore.retreiveNameFromTranslation(
                          aMenu.title
                        )}       `}
                      </div>

                      <Box
                        style={{
                          alignSelf: "flex-end",
                          color: (Environment.isPopina) ? "#42b983" : "#ffd400",
                          display: "flex",
                          marginBottom: "10px",
                          marginRight: "15px",
                        }}
                      >
                        <Avatar
                          style={AvatarCardStyle}
                          onClick={(_e) => {
                            this.handleSelectMenu(aMenu);
                          }}
                        >
                          <Icon key={`icon_edit_${aMenu.id}`}>
                            <EditOutlined style={{ color: (Environment.isPopina) ? "#42b983" : "#ffd400" }} />
                          </Icon>
                        </Avatar>
                        <Avatar
                          style={AvatarCardStyle}
                          onClick={(_e) => {
                            this.handleTapDeleteMenu(aMenu);
                          }}
                        >
                          <Icon>
                            <DeleteForeverOutlined
                              style={{
                                color: (Environment.isPopina) ? "#42b983" : "#ffd400",
                              }}
                            />
                          </Icon>
                        </Avatar>
                      </Box>
                    </span>
                  </MenuStyledButton>
                );
              })}
              {/* <div style={fakeImg}>
                <AddProductButton
                  onClick={(_e) => {
                    this.handleTappAddMenu();
                  }}
                >
                  <Avatar style={AvatarAddStyle}>
                    <Add />
                  </Avatar>
                  <span>Ajouter un Menu</span>
                </AddProductButton>
              </div> */}
            </CardContent>
          </Card>
        </div>

        {this.props.store.categories
          .sort((a, b) => {
            const nameA = DeliveraStore.retreiveNameFromTranslation(a.title);
            const nameB = DeliveraStore.retreiveNameFromTranslation(b.title);
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          })
          .map((aCategory) => {
            return (
              <div
                style={{ backgroundColor: "#f9fafa", marginTop: "30px" }}
                key={aCategory.id}
              >
                {/* <Accordion> */}
                <Card
                  style={{
                    margin: "10px 3em",
                  }}
                >
                  {/* <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    > */}
                  <CardHeader
                    subheaderTypographyProps={{
                      style: {
                        color: "white",
                      },
                    }}
                    titleTypographyProps={{
                      style: {
                        fontWeight: "bold",
                        fontSize: "20px",
                      },
                    }}
                    style={{
                      backgroundColor: "#474F5E",
                      color: "white",
                    }}
                    title={DeliveraStore.retreiveNameFromTranslation(
                      aCategory.title
                    )}
                    subheader={DeliveraStore.retreiveNameFromTranslation(
                      aCategory.subtitle
                    )}
                    action={
                      <Box style={{ display: "flex" }}>
                        <Avatar
                          style={{
                            marginRight: "7px",
                            width: "30px",
                            height: "30px",
                            cursor: "grab",
                          }}
                        >
                          <Icon
                            key={`icon_edit_${aCategory.id}`}
                            onClick={(_e) => {
                              this.handleTapEditCategory(aCategory);
                            }}
                          >
                            <EditOutlined style={{ color: "white" }} />
                          </Icon>
                        </Avatar>
                        {/* <Avatar
                          style={{
                            width: "30px",
                            height: "30px",
                            cursor: "grab",
                          }}
                        >
                          <Icon>
                            <DeleteForeverOutlined style={{ color: "white" }} />
                          </Icon>
                        </Avatar> */}
                      </Box>
                    }
                  />
                  {/* </AccordionSummary>
                    <AccordionDetails> */}
                  <CardContent
                    style={{
                      flexWrap: "wrap",
                      display: "flex",
                      backgroundColor: "#F1F1F5",
                      alignItems: "stretch",
                    }}
                  >
                    {this.props.store
                      .getItemInCategory(aCategory)
                      .map((aItem, i) => {
                        return (
                          <ItemCategoryComponent
                            item={aItem}
                            onSelect={(i) => {
                              this.handleSelectItem(i, aCategory);
                            }}
                            key={i}
                          />
                        );
                      })}
                    <div style={{ width: "30%" }} key={"add_item_key"}>
                      <div style={fakeImg}>
                        <AddProductButton
                          onClick={(_e: any) => {
                            this.handleTapAddItem(aCategory);
                          }}
                        >
                          <Avatar style={AvatarAddStyle}>
                            <Add />
                          </Avatar>
                          <span>Ajouter un produit</span>
                        </AddProductButton>
                      </div>
                    </div>
                  </CardContent>
                  {/* </AccordionDetails> */}
                </Card>
                {/* </Accordion> */}
              </div>
            );
          })}

        <Card
          style={{
            position: "static",
            background: "#F1F1F5",
            padding: "24px",
            border: "1px solid rgba(0,0,0,.04)",
            borderRadius: "3px",
            margin: "20px 3em",
          }}
        >
          <div style={fakeImg}>
            <AddProductButton
              onClick={(_e: any) => {
                this.handleTapAddCategory();
              }}
            >
              <Avatar style={AvatarAddStyle}>
                <Add />
              </Avatar>
              <span>Ajouter une catégorie</span>
            </AddProductButton>
          </div>
        </Card>

        <Card
          style={{ backgroundColor: "#f9fafa", margin: "20px 3em" }}
          key={"groupe_option_list"}
        >
          <CardHeader
            title="Groupe d'option"
            subheader="Groupe regroupant les différentes options utilisées pour un produit"
            subheaderTypographyProps={{
              style: {
                color: "white",
              },
            }}
            titleTypographyProps={{
              style: {
                fontWeight: "bold",
                fontSize: "20px",
              },
            }}
            style={{
              backgroundColor: "#474F5E",
              color: "white",
            }}
          />

          <CardContent
            style={{
              backgroundColor: "#F1F1F5",
            }}
          >
            {this.props.store.modifier_groups.map((aGroupe) => {
              return (
                <div
                  key={`${aGroupe.id}_${new Date().toISOString()}`}
                  style={{
                    border: (Environment.isPopina) ? "1px solid #707070 " : "1px solid #ffd400",
                    borderRadius: "3px",
                    backgroundColor: "white",
                    flex: "1 1 0%",
                    display: "flex",
                    cursor: "pointer",
                    outline: "0px",
                    margin: "5px",
                    padding: "17px",
                  }}
                  onClick={(_e) => {
                    this.handleSelectGroupeOption(aGroupe);
                  }}
                >
                  <div
                    style={{
                      fontSize: "19px",
                      color: "#474F5E",
                      alignItems: "center",
                      display: "flex",
                      paddingLeft: "20px",
                      visibility: "visible",
                      width: "15%",
                      fontWeight: "bold",
                    }}
                  >
                    {DeliveraStore.retreiveNameFromTranslation(aGroupe.title)}
                  </div>
                  <div
                    style={{
                      WebkitBoxAlign: "center",
                      alignItems: "center",
                      display: "flex",
                      paddingLeft: "60%",
                      visibility: "visible",
                      width: "35%",
                      color: "#474F5E",
                    }}
                  >
                    {(aGroupe.modifier_options != null) ? `${aGroupe.modifier_options.length} élèments` : "0 élèments"}
                  </div>
                  <Avatar style={AvatarCardStyle}>
                    <EditOutlined />
                  </Avatar>
                </div>
              );
            })}

            <div style={fakeImg}>
              <AddProductButton
                onClick={(_e: any) => {
                  this.handleTapAddGroupeOption();
                }}
                style={{ padding: "20px" }}
              >
                <Avatar style={AvatarAddStyle}>
                  <Add />
                </Avatar>
                <span>Ajouter un groupe d'option</span>
              </AddProductButton>
            </div>
          </CardContent>
        </Card>

        <Card
          style={{ backgroundColor: "#f9fafa", margin: "20px 3em" }}
          key={"option_groupe"}
        >
          <CardHeader
            title="Options / Ingrédients "
            subheader="Produits servent d'option et d'ingrédient (sauce, supplément ... )"
            subheaderTypographyProps={{
              style: {
                color: "white",
              },
            }}
            titleTypographyProps={{
              style: {
                fontWeight: "bold",
                fontSize: "20px",
              },
            }}
            style={{
              backgroundColor: "#474F5E",
              color: "white",
            }}
          />

          <CardContent
            style={{
              flexWrap: "wrap",
              display: "flex",
              backgroundColor: "#F1F1F5",
              alignItems: "stretch",
            }}
          >
            {this.props.store.getItemWithoutGroupe().map((aItem) => {
              return (
                <ItemCategoryComponent
                  item={aItem}
                  onSelect={(i) => {
                    this.handleSelectItem(i, undefined);
                  }}
                />
              );
            })}
            <div style={{ width: "30%" }}>
              <div style={fakeImg}>
                <AddProductButton
                  onClick={(_e: any) => {
                    this.handleTapAddItem(undefined);
                  }}
                >
                  <Avatar style={AvatarAddStyle}>
                    <Add />
                  </Avatar>
                  <span>Ajouter un produit</span>
                </AddProductButton>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  private handleTapAddGroupeOption() {
    this.groupeOptionModalRef.current?.openOptionModal(undefined, undefined);
  }

  private handleTapCreateGroupeOption(
    groupeOption: DeliveraModifierGroupInterface
  ) {
    DeliveraActionCreators.addGroupeModifier(groupeOption, this.props.store);
    this.groupeOptionModalRef.current?.handleCloseModal();
  }

  private handleTapAddCategory() {
    this.categoryDetailModalRef.current?.openModalWithCategory(undefined);
  }

  private createCategorie(category: DeliveraCategoryInterface) {
    DeliveraActionCreators.createCategory(category, this.props.store);
    this.categoryDetailModalRef.current?.handleCloseModal();
  }

  private handleTapAddItem(category: DeliveraCategory | undefined) {
    this.itemDetailModalRef.current?.openModalWithItem(
      undefined,
      category?.toJS() as DeliveraCategoryInterface ?? undefined
    );
  }

  private handleTappAddMenu() {
    // console.log("ajouter un menu");
  }

  private handleTapEditCategory(category: DeliveraCategory) {
    this.categoryDetailModalRef.current?.openModalWithCategory(category.toJS() as DeliveraCategoryInterface);
  }

  private handleSelectGroupeOption(
    groupeOption: DeliveraModifierGroupInterface | undefined
  ) {
    this.groupeOptionModalRef.current?.openOptionModal(
      groupeOption,
      this.itemDetailModalRef.current!.state.item!
    );
  }

  private handleSelectItem(
    item: DeliveraItem,
    category: DeliveraCategory | undefined
  ) {
    this.itemDetailModalRef.current?.openModalWithItem(
      item.toJS() as DeliveraItemInterface,
      category?.toJS() as DeliveraCategoryInterface ?? undefined
    );
  }

  private updateItem(item: DeliveraItemInterface) {
    DeliveraActionCreators.updateItemOnStore(item, this.props.store);
    this.itemDetailModalRef.current?.handleCloseModal(null);
  }

  private updateCategory(category: DeliveraCategoryInterface) {
    DeliveraActionCreators.updateCategory(category, this.props.store);
    this.categoryDetailModalRef.current?.handleCloseModal();
  }

  private removeItemFromCatgory(
    item: DeliveraItemInterface,
    category: DeliveraCategoryInterface
  ) {
    if (category === undefined || category === null) {
      DeliveraActionCreators.removeItem(item, this.props.store);
    } else {
      DeliveraActionCreators.removeItemFromCategoryInStore(
        item,
        category,
        this.props.store
      );
    }
    this.itemDetailModalRef.current?.handleCloseModal();
  }

  private createItemInCategory(
    item: DeliveraItemInterface,
    category: DeliveraCategoryInterface
  ) {
    if (category === undefined) {
      this.addItem(item);
    } else {
      DeliveraActionCreators.addItemOnCategorieInStore(
        item,
        category,
        this.props.store
      );
    }
    this.itemDetailModalRef.current?.handleCloseModal();
  }

  private deleteGroupeModifierFromItem(
    groupeModifier: DeliveraModifierGroupInterface,
    item: DeliveraItemInterface
  ) {
    DeliveraActionCreators.removeModifierGroupeFromItemInStore(
      groupeModifier,
      item,
      this.props.store
    );
    this.groupeOptionModalRef.current?.handleCloseModal();
    this.itemDetailModalRef.current?.handleCloseModal();
  }

  private updateGroupeModifier(groupeModifier: DeliveraModifierGroupInterface) {
    DeliveraActionCreators.updateModifierGroupeInStore(
      groupeModifier,
      this.props.store
    );
    this.groupeOptionModalRef.current?.handleCloseModal();
  }

  private addItem(item: DeliveraItemInterface) {
    DeliveraActionCreators.addItemOnStore(item, this.props.store);
    this.itemDetailModalRef.current?.handleCloseModal();
  }

  private handleSelectMenu(menu: DeliveraMenu) {
    this.menuDetailModalRef.current?.openModalWithMenu(menu);
  }

  private handlTapSaveMenu(menu: DeliveraMenuInterface) {
    DeliveraActionCreators.updateMenu(menu, this.props.store);
    this.menuDetailModalRef.current?.closeModal();
  }

  private handleTapDeleteMenu(menu: DeliveraMenu) {
    swal({
      title: "Supprimer ce Menu ?",
      text: `Êtes vous sur de vouloir supprimer le Menu  ${menu.title}`,
      icon: "warning",
      buttons: ["Non", "Oui"],
      dangerMode: true,
    }).then((result) => {
      const index = this.props.store.menus?.findIndex((m) => m.id === menu.id);
      if (result === true) {
        if (index === -1 || index === undefined) {
          throw new Error("Menu not found");
        } else if (index === 0) {
          swal({
            title: `Impossible de supprimer ce menu`,
            text: `Il doit y rester au minimum 1 menu`,
            icon: "warning",
            buttons: ["OK"],
            dangerMode: true,
          })
            .then((_v) => {
              return;
            })
            .catch((e) => {
              console.warn(e);
              return;
            });
        } else {
          DeliveraActionCreators.deleteMenu(menu, this.props.store);
        }
      }
    });
  }
}

const MenuStyledButton = styled('button')({
  root: {
    width: "300px",
    height: "200px",
    border: (Environment.isPopina) ? "1px solid #7ABF92" : "1px solid #ffd400",
    borderRadius: "3px",
    margin: "5px",
    backgroundColor: "white",
    "&:hover": {
      borderColor: "#474F5E",
      color: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
      backgroundColor: "#474F5E",
    },
  },
});

const AddCategoButton = styled('button')({
  root: {
    marginLeft: "auto",

    marginRight: "3rem",
    color: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
    padding: "10px",
    border: (Environment.isPopina) ? "1px solid #7ABF92" : "1px solid #ffd400",
    borderRadius: "3px",

    display: "flex",
    flexDirection: "column",
    "&:hover": {
      borderColor: "#474F5E",
      color: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
      backgroundColor: "#474F5E",
    },
  },
});

const AddProductButton = styled('button')({
  root: {
    color: "#474F5E",
    textTransform: "capitalize",
    width: "100%",
    borderRadius: "3px",
    fontSize: "17px",
    cursor: "pointer",
    alignItems: "center",
    "&:hover": {
      borderColor: "#474F5E",
      color: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
      backgroundColor: "#474F5E",
    },
  },
});

const fakeImg: CSSProperties = {
  backgroundImage:
    "url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnPgogIDxyZWN0CiAgICB3aWR0aD0nMTAwJScKICAgIGhlaWdodD0nMTAwJScKICAgIGZpbGw9J3RyYW5zcGFyZW50JwogICAgcng9JzMnCiAgICByeT0nMycKICAgIHN0cm9rZT0ncmdiYSgwLCAwLCAwLCAwLjE2KScKICAgIHN0cm9rZS13aWR0aD0nMicKICAgIHN0cm9rZS1kYXNoYXJyYXk9JzYsIDEyJwogICAgc3Ryb2tlLWRhc2hvZmZzZXQ9JzAnCiAgICBzdHJva2UtbGluZWNhcD0nc3F1YXJlJwogIC8+Cjwvc3ZnPgo=')",
  borderRadius: "3px",
  flex: "1 1 0%",
  minHeight: "140px",
  minWidth: "30%",
  display: "flex",
  backgroundColor: "white",
  margin: "16px 10px",
};

const AvatarAddStyle: CSSProperties = {
  color: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
  backgroundColor: "white",
  border: (Environment.isPopina) ? "1px solid #7abf92" : "1px solid #ffd400",
  width: "22px",
  height: "22px",
  marginRight: "10px",
};

const AvatarCardStyle: CSSProperties = {
  color: (Environment.isPopina) ? "#7ABF92" : "#ffd400",
  backgroundColor: "#fff",
  border: (Environment.isPopina) ? "1px solid #7abf92" : "1px solid #ffd400",
  marginLeft: "10px",
  width: "25px",
  height: "25px",
  padding: "7px",
};
